import {
  STORE_ASSESSMENT_REPORT_DETAILS,
  SET_ASSESSMENT_REPORT_DOWNLOAD_LOADER,
  SET_STORY_PLAY_MODE,
  SET_ASSESSMENT_SHARE_POPUP_VIEW,
  SET_REPORT_CONFIG,
  TOGGLE_CSAT_FORM,
  SET_CSAT_DEFAULT_CONFIG,
  SET_REPORT_TYPE,
  SHOW_DOWNLOAD_BUTTON,
} from 'redux/actions/actionTypes';

const initialState = {
  caseId: '',
  context: {},
  conditons: [],
  generalAdvice: [],
  inference: {},
  redFlags: [],
  isLoading: false,
  isAssessmentReportDownloading: false,
  storyPlayMode: 'all',
  storyPlayCardIndex: 0,
  showAssessmentSharePopUp: false,
  config: {},
  isCSATDone: false,
  reportType: 'v2',
  showDownloadButton: false,
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case STORE_ASSESSMENT_REPORT_DETAILS: {
      return {
        ...state,
        ...payload,
      };
    }
    case SET_ASSESSMENT_REPORT_DOWNLOAD_LOADER: {
      return {
        ...state,
        isAssessmentReportDownloading: payload,
      };
    }
    case SET_STORY_PLAY_MODE: {
      return {
        ...state,
        storyPlayMode: payload.mode,
        storyPlayCardIndex: payload.index,
      };
    }
    case SET_ASSESSMENT_SHARE_POPUP_VIEW: {
      return {
        ...state,
        showAssessmentSharePopUp: payload,
      };
    }
    case SET_REPORT_CONFIG: {
      return {
        ...state,
        config: payload,
      };
    }
    case TOGGLE_CSAT_FORM: {
      return {
        ...state,
        isCSATDone: payload,
      };
    }
    case SET_CSAT_DEFAULT_CONFIG: {
      return {
        ...state,
        isCSATDone: false,
      };
    }
    case SET_REPORT_TYPE: {
      return {
        ...state,
        reportType: payload,
      };
    }
    case SHOW_DOWNLOAD_BUTTON: {
      return {
        ...state,
        showDownloadButton: payload?.showDownloadButton || initialState.showDownloadButton,
      };
    }

    default:
      return state;
  }
};
